import { useEffect, useState } from 'react'

interface UseHasScroll {
  overflowContainerRef: React.RefObject<HTMLDivElement | null>
}

export default function useHasScroll({ overflowContainerRef }: UseHasScroll) {
  const [hasScrolled, setHasScrolled] = useState(false)
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = overflowContainerRef.current?.scrollTop ?? 0
      setHasScrolled(scrollPosition > 0)
    }

    const current = overflowContainerRef.current
    current?.addEventListener('scroll', handleScroll)

    return () => {
      current?.removeEventListener('scroll', handleScroll)
    }
  }, [overflowContainerRef])

  return hasScrolled
}
